import { setTerms } from '@/packages/JsonQuery/helpers';

export const setCraneType = setTerms('building_cranage_types_type');
